import { ApiResponse } from './api-response';

export function parseResult<T>(response: Response): Promise<ApiResponse<T>> {
  if (response.ok) {
    return response.json();
  }
  return Promise.resolve({
    statusCode: response.status,
    success: false,
    error: response.statusText
      ? { message: response.statusText, code: response.status.toString() }
      : { message: 'Unknown error', code: 'unknown' },
    validationErrors: null,
    result: null
  });
}
